<template>
  <div class="loader-overlay" v-if="isLoader">
    <div class="loader-circular"></div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  name: 'Loader',
  props: { isLoader: Boolean },
}
</script>
<style scoped>
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(52, 58, 64, 0.9);
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader-circular {
  display: block;
  position: relative;
  left: 50%;
  top: 50%;
  width: 150px;
  height: 150px;
  margin: -75px 0 0 -75px;
  border-radius: 50%;
  border: 6px solid transparent;
  border-top-color: #5284b9;
  animation: spin 2s linear infinite;
}

.loader-circular:before {
  content: "";
  position: absolute;
  top: 5px;
  left: 5px;
  right: 5px;
  bottom: 5px;
  border-radius: 50%;
  border: 6px solid transparent;
  border-top-color: #ffffff;
  animation: spin 21s linear infinite;
}

.loader-circular:after {
  content: "";
  position: absolute;
  top: 15px;
  left: 15px;
  right: 15px;
  bottom: 15px;
  border-radius: 50%;
  border: 6px solid transparent;
  border-top-color: lightgrey;
  animation: spin 1.5s linear infinite;
}
</style>